declare namespace $ {

	type $mol_text__text_shm_tests_screenshots_1 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['screenshot_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_image__uri_shm_tests_screenshots_2 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['screenshot_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_tests_screenshots_3 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['screenshot_description'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_text__text_shm_tests_screenshots_4 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['summary_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_tests_visual__comparison_shm_tests_screenshots_5 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['visual'] >
		,
		ReturnType< $shm_tests_visual['comparison'] >
	>
	type $shm_tests_visual__manifest_uri_shm_tests_screenshots_6 = $mol_type_enforce<
		ReturnType< $shm_tests_screenshots['manifest_uri'] >
		,
		ReturnType< $shm_tests_visual['manifest_uri'] >
	>
	type $mol_view__sub_shm_tests_screenshots_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_tests_screenshots_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_tests_screenshots extends $mol_page {
		screenshot_rows( ): readonly($mol_view)[]
		summary_text( ): string
		screenshot_description( id: any): string
		Description( id: any): $mol_text
		screenshot_uri( id: any): string
		Image( id: any): $mol_image
		result( ): any
		manifest_uri( ): string
		visual( id: any): any
		title( ): string
		body( ): ReturnType< $shm_tests_screenshots['screenshot_rows'] >
		Summary( ): $mol_text
		Visual( id: any): $shm_tests_visual
		Screenshot( id: any): $mol_view
		Empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=screenshots.view.tree.d.ts.map